import { getPhoneSession } from './sessionHandler'

export default () => {
  const phone = getPhoneSession()
  phone.stop()
}
